import { HOBBIES } from '@/lib/constants';

export default function HobbiesPicker({ selected, onChange, max = 5, title, subtitle }) {
  const atMax = selected.length >= max;

  const toggle = (hobby) => {
    if (selected.includes(hobby)) {
      onChange(selected.filter(h => h !== hobby));
    } else {
      if (atMax) return;
      onChange([...selected, hobby]);
    }
  };

  const renderChip = (hobby) => {
    const isSelected = selected.includes(hobby);
    const isDimmed = atMax && !isSelected;

    let cls;
    if (isSelected) {
      cls = 'bg-[#C857A8] border-[#C857A8] text-white';
    } else {
      cls = 'bg-white border-[rgba(0,0,0,0.10)] text-[#1A1814]';
    }

    return (
      <button
        key={hobby}
        onClick={() => toggle(hobby)}
        disabled={isDimmed}
        style={{ minHeight: 36 }}
        className={`px-4 rounded-full border text-sm transition-colors ${cls} ${isDimmed ? 'opacity-40 cursor-default' : ''}`}
      >
        {hobby}
      </button>
    );
  };

  return (
    <div>
      {title && <p className="text-sm font-semibold text-[#1A1814] mb-1">{title}</p>}
      {subtitle && <p className="text-xs text-[#7A7672] mb-3">{subtitle}</p>}

      {Object.entries(HOBBIES).map(([category, hobbies]) => (
        <div key={category} className="mb-4">
          <p className="text-[11px] uppercase tracking-wider text-[#A8A5A0] font-semibold mb-2">{category}</p>
          <div className="flex flex-wrap gap-2">
            {hobbies.map(renderChip)}
          </div>
        </div>
      ))}

      <p className={`text-xs font-medium ${selected.length === max ? 'text-[#C857A8]' : 'text-[#A8A5A0]'}`}>
        {selected.length}/{max} selected
      </p>
    </div>
  );
}
